// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filtered_list_styles{margin-top:13rem!important}@media screen and (max-width:790px){.filtered_list_styles{margin-top:14rem!important}}#today{color:#27846d}.emptyDay{margin-left:1.3rem}", ""]);
// Exports
module.exports = exports;
